import React from "react";
import { motion } from "framer-motion";

export default function EmployeeDetails() {
  // PAGE CONTAINER ANIMATION
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  // CARD ANIMATION
  const card = {
    hidden: { opacity: 0, y: 30 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  // TAP ANIMATION STYLE (REUSABLE)
  const tapEffect = {
    whileTap: { scale: 0.92 },
    whileHover: { scale: 1.03 },
    transition: { type: "spring", stiffness: 300, damping: 15 },
  };

  return (
    <motion.div
      className="container-fluid p-3"
      variants={container}
      initial="hidden"
      animate="show"
    >
      <h5 className="fw-bold mb-3">Employee Details</h5>

      <div className="row g-3">
        {/* LEFT CARD */}
        <div className="col-lg-4">
          <motion.div
            className="card p-3 shadow-sm border-0 h-100"
            variants={card}
            whileHover={{ y: -8 }}
          >
            {/* HEADER */}
            <div className="d-flex align-items-center mb-3">
              <motion.img
                src="/img1.jpg"
                className="rounded-circle me-3"
                alt="employee"
                width="60"
                height="60"
                whileHover={{ scale: 1.1, rotate: 2 }}
              />

              <div>
                <h6 className="mb-1">Lewis Hamilton</h6>
                <span className="badge bg-primary me-1">Developer</span>
                <span className="badge bg-secondary">2+ Years</span>
              </div>
            </div>

            <p className="small text-muted">
              UI/UX Developer with strong experience.
            </p>

            {/* BUTTONS WITH TAP ANIMATION */}
            <div className="d-flex gap-2 mb-3">
              <motion.button
                className="btn btn-outline-dark btn-sm w-50"
                {...tapEffect}
              >
                Edit
              </motion.button>

              <motion.button
                className="btn btn-outline-secondary btn-sm w-50"
                {...tapEffect}
              >
                Message
              </motion.button>
            </div>

            <hr />

            <h6>Basic Info</h6>
            <p className="small mb-1">Phone: 9876543210</p>
            <p className="small mb-1">Email: test@gmail.com</p>
            <p className="small mb-1">Gender: Male</p>
            <p className="small mb-1">DOB: 24 July 2000</p>
            <p className="small">Address: London</p>

            <hr />

            <h6>Personal Info</h6>
            <p className="small mb-1">Nationality: Indian</p>
            <p className="small mb-1">Religion: Hindu</p>
            <p className="small mb-1">Status: Active</p>
            <p className="small">Passport: ABC1234</p>
          </motion.div>
        </div>

        {/* RIGHT SIDE */}
        <div className="col-lg-8">
          {/* EMERGENCY */}
          <motion.div
            className="card p-3 mb-3 shadow-sm border-0"
            variants={card}
            whileHover={{ y: -6 }}
          >
            <h6>Emergency Contact</h6>

            <div className="d-flex justify-content-between">
              <div>
                <b>Adrain</b>
                <br />
                <small>Father</small>
              </div>
              <div>+91 9999999999</div>
            </div>

            <hr />

            <div className="d-flex justify-content-between">
              <div>
                <b>Karen</b>
                <br />
                <small>Mother</small>
              </div>
              <div>+91 8888888888</div>
            </div>
          </motion.div>

          {/* BANK */}
          <motion.div
            className="card p-3 mb-3 shadow-sm border-0"
            variants={card}
            whileHover={{ y: -6 }}
          >
            <h6>Bank Info</h6>

            <div className="row small">
              <div className="col-6">Bank: XYZ Bank</div>
              <div className="col-6">IFSC: ABC123</div>
              <div className="col-6 mt-2">Account: 123456789</div>
              <div className="col-6 mt-2">Branch: USA</div>
            </div>
          </motion.div>

          {/* EDUCATION + EXPERIENCE */}
          <div className="row g-3">
            <div className="col-md-6">
              <motion.div
                className="card p-3 h-100 shadow-sm border-0"
                variants={card}
                whileHover={{ y: -6 }}
              >
                <h6>Education</h6>

                <p className="small mb-2">
                  Computer Science
                  <br />
                  <span className="text-muted">Oxford (2020-2022)</span>
                </p>

                <p className="small">
                  Computer Science
                  <br />
                  <span className="text-muted">Oxford (2016-2019)</span>
                </p>
              </motion.div>
            </div>

            <div className="col-md-6">
              <motion.div
                className="card p-3 h-100 shadow-sm border-0"
                variants={card}
                whileHover={{ y: -6 }}
              >
                <h6>Experience</h6>

                <p className="small mb-1">Google</p>
                <p className="small mb-1">Salesforce</p>
                <p className="small">Hubspot</p>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

